export const GENDERS = ['man', 'woman'] as const;

export type Gender = (typeof GENDERS)[number];
